function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.224 9.5c-6.373.16-6.144 4.265-6.144 6.505 0 2.595-4.698-2.75-4.698-6.144 0-3.393 2.167-5.61 4.698-6.144 6.867-1.445 9.035 5.71 6.144 5.783z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.333 19.692a2.53 2.53 0 11-5.06 0 2.53 2.53 0 115.06 0z",
  fill: "none",
  strokeWidth: 0.99967389
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.96 20.415c3.325 5.44 6.766 3.189 8.706 2.068 2.248-1.297-.033 5.444-2.971 7.14-2.94 1.698-5.944.93-7.67-.996-4.686-5.224.427-10.68 1.935-8.212zM32.457 28.627c3.048-5.599-.622-7.453-2.562-8.574-2.247-1.297 4.731-2.693 7.67-.996 2.939 1.696 3.776 4.682 2.972 7.14-2.182 6.67-9.463 4.97-8.08 2.43z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.874 19.692a18.07 18.07 0 11-36.142 0 18.07 18.07 0 1136.142 0z",
  fill: "none",
  strokeWidth: 0.99967389
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.358 37.718l-.738 9.54c-5.18.882-8.98 3.921-8.98 8.242h24.34c0-4.315-3.812-7.325-8.98-8.212l-.738-9.57c-1.373.203-3.19.138-4.904 0z",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeWidth: 1.058
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.392 51.246a1.418 1.418 0 11-2.836 0 1.418 1.418 0 012.836 0zM31.063 51.246a1.418 1.418 0 11-2.835 0 1.418 1.418 0 012.835 0z",
  strokeWidth: 1.00006392
})));

var SvgFan = function SvgFan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Fan.e8de88bd.svg";
export { ForwardRef as ReactComponent };